import * as _ from 'lodash';
import { DataTable, SelectItem } from 'primeng/primeng';

export interface IServiceEventColumn {
    field: string,
    header: string,
    style: any,
    show: boolean,
    disabled?: boolean,
    editable?: boolean,
    checked?: boolean,
}

export class EventSearchTableHelper {
    public PostedClaimsColumns: IServiceEventColumn[];
    public PostedClaimsColumnOptions: SelectItem[];
    public UnpostedClaimsColumns: IServiceEventColumn[];
    public UnpostedClaimsColumnOptions: SelectItem[];
    public TransactionHistoryColumnOptions: SelectItem[];
    public PostedRemittanceColumns: IServiceEventColumn[];
    public PostedRemittanceColumnOptions: SelectItem[];
    public UnpostedRemittanceColumns: IServiceEventColumn[];
    public UnpostedRemittanceColumnOptions: SelectItem[];
    public AdjustmentCodeColumns: IServiceEventColumn[];
    public TransactionHistoryColumns: IServiceEventColumn[];
    public AuditHistoryColumns: IServiceEventColumn[];
    public AuditHistoryColumnsOptions: SelectItem[];
    constructor() {
        this.generatePostedClaimsColumns();
        this.PostedClaimsColumnOptions = this.generateColumnOptions(this.PostedClaimsColumns);
        this.generateUnpostedClaimsColumns();
        this.UnpostedClaimsColumnOptions = this.generateColumnOptions(this.UnpostedClaimsColumns);
        this.generatePostedRemittanceColumns();
        this.PostedRemittanceColumnOptions = this.generateColumnOptions(this.PostedRemittanceColumns);
        this.generateUnpostedRemittanceColumns();
        this.UnpostedRemittanceColumnOptions = this.generateColumnOptions(this.UnpostedRemittanceColumns);
        this.generateAdjCodeColumns();

        this.generateTransactionHistoryColumns();
        this.TransactionHistoryColumnOptions = this.generateColumnOptions(this.TransactionHistoryColumns);
        this.generateAuditHistoryColumns();
        this.AuditHistoryColumnsOptions = this.generateColumnOptions(this.AuditHistoryColumns);

    }

    isVisible(collection, dtCol) {
        for (let col of collection) {
            if (col.field === dtCol.field) {
                return true;
            }
        }
        return false;
    }

    generateColumnOptions(columns: IServiceEventColumn[]): SelectItem[] {
        if (!columns) {
            return null
        }
        let options = []
        for (let col of columns) {
            if (col.field === 'status') {
                continue;
            }
            options.push({label: col.header, value: col});
        }
        return options
    }

    showHideColumn(index: number, columnsRef: IServiceEventColumn[]): void {
        columnsRef[index].show = !columnsRef[index].show;
    }

    hideColumn(index: number, columnsRef: IServiceEventColumn[]): void {
        columnsRef[index].show = false;
    }

    showColumn(index: number, columnsRef: IServiceEventColumn[]): void {
        columnsRef[index].show = true;
    }

    uncheckRows(dataTable: DataTable): void {
       let index = _.findIndex(dataTable.value, {status: true});
       if (index > -1) {
         dataTable.value[index].status = false;
       }
    }

    generatePostedClaimsColumns(): void {
        this.PostedClaimsColumns = [
            { field: 'status', header: 'Select', style: {width: '80px'}, show: true, disabled: false},
            { field: 'AREngine_PostSystemDate', header: 'Post Date', style: '', show: true },
            { field: 'Prescription_PrescriptionNumber', header: 'Rx', style: '', show: true  },
            { field: 'Prescription_FillDate', header: 'Fill Date', style: '', show: true },
            { field: 'AREngine_TransactionCode', header: 'Trans. Type', style: '', show: true  },
            { field: 'Prescription_SplitBillCode', header: 'COB', style: '', show: true  },
            { field: 'Prescription_SoldDate', header: 'Sold Date', style: '', show: true  },
            { field: 'Location_NCPDPProviderIdentifier', header: 'NCPDP', style: {}, show: true  },
            { field: 'Location_NationalProviderIdentifier', header: 'NPI', style: '', show: true  },
            { field: 'Location_CorporateLocationNumber', header: 'Store', style: '', show: true },
            { field: 'Payer_ProcessorIdentifier', header: 'Carrier', style: '' , show: true },
            { field: 'Payer_ShardPayerName', header: 'Carrier Name', style: '' , show: true },
            { field: 'Payer_ShardPayerGroupIdentifier', header: 'Carrier Group Id', style: '' , show: true },
            { field: 'Payer_PlanCode', header: 'Plan Code', style: '' , show: true },
            { field: 'Payer_PlanName', header: 'Plan Name', style: '' , show: true },
            { field: 'Money_TransactionPriceClaim', header: 'Trans. Price', style: {'text-align': 'right'} , show: true },
            { field: 'Money_CoPayAmountClaim', header: 'CoPay', style: {'text-align': 'right'}, show: true  },
            { field: 'Money_PayerReceivableAmountClaim', header: 'A/R Amt.', style: {'text-align': 'right'}, show: true  },
            { field: 'Money_OpenAmountClaim', header: 'Open Amt.', style: {'text-align': 'right'}, show: true  },
            { field: 'HasAuditHistory' , header: 'Audit', style: {width: '80px'}, show: true},
            { field: 'IsRelatedItem', header: 'Assign', style: {width: '70px'}, show: true  },
        ]
    }

    generateUnpostedClaimsColumns(): void {
        this.UnpostedClaimsColumns = [
            { field: 'AREngine_PostSystemDate', header: 'Receive Date', style: '', show: true  },
            { field: 'Prescription_PrescriptionNumber', header: 'Rx', style: '', show: true  },
            { field: 'Prescription_FillDate', header: 'Fill Date', style: '', show: true },
            { field: 'AREngine_TransactionCode', header: 'Trans. Type', style: '', show: true  },
            { field: 'Prescription_SplitBillCode', header: 'Is Split Bill', style: '', show: true  },
            { field: 'Prescription_SoldDate', header: 'Sold Date', style: '', show: true  },
            { field: 'Location_NCPDPProviderIdentifier', header: 'NCPDP', style: {}, show: true  },
            { field: 'Location_NationalProviderIdentifier', header: 'NPI', style: '', show: true  },
            { field: 'Location_CorporateLocationNumber', header: 'Store', style: {}, show: true  },
            { field: 'Payer_ProcessorIdentifier', header: 'Carrier', style: '', show: true  },
            { field: 'Payer_ShardPayerName', header: 'Carrier Name', style: '', show: true  },
            { field: 'Payer_ShardPayerGroupIdentifier', header: 'Carrier Group Id', style: '', show: true  },
            { field: 'Payer_PlanCode', header: 'Plan Code', style: '', show: true  },
            { field: 'Payer_PlanName', header: 'Plan Name', style: '', show: true  },
            { field: 'Money_TransactionPriceClaim', header: 'Trans. Price', style: {'text-align': 'right'}, show: true  },
            { field: 'Money_CoPayAmountClaim', header: 'CoPay', style: {'text-align': 'right'}, show: true  },
            // { field: 'HasAuditHistory' , header: 'Audit', style: {width: '80px'}, show: true},
            { field: 'IsRelatedItem', header: 'Assign', style: {width: '70px'}, show: true  },
        ]
    }

    generatePostedRemittanceColumns(): void {
        this.PostedRemittanceColumns = [
            { field: 'status', header: 'Select', style: {width: '80px'}, show: true, disabled: false},
            { field: 'AdjCode', header: 'Adj.', style: {width: '50px'}, show: true},
            { field: 'RawDataImport_ReceivedDate', header: 'Post Date', style: '', show: true},
            { field: 'Prescription_PrescriptionNumber', header: 'Rx', style: '', show: true  },
            { field: 'Prescription_FillDate', header: 'Fill Date', style: '', show: true },
            { field: 'Money_PaymentStatusCode', header: 'Payment Status', style: '', show: true  },
            { field: 'Location_NCPDPProviderIdentifier', header: 'NCPDP', style: {}, show: true  },
            { field: 'Location_NationalProviderIdentifier', header: 'NPI', style: '', show: true  },
            { field: 'Location_CorporateLocationNumber', header: 'Store', style: {}, show: true  },
            { field: 'AREngine_UnappliedCashCategory', header: 'UAC Cat.', style: {}, show: true },
            { field: 'Payer_ProcessorIdentifier', header: 'Carrier', style: '', show: true  },
            { field: 'Payer_ShardPayerName', header: 'Carrier Name', style: '', show: true  },
            { field: 'Payer_ShardPayerGroupIdentifier', header: 'Carrier Group Id', style: '', show: true  },
            { field: 'Money_PaidAmount', header: 'Paid Amt.', style: {'text-align': 'right'} , show: true  },
            { field: 'AREngine_UnappliedAmount', header: 'Unapplied Amt.', style: {'text-align': 'right'} , show: true  },
            { field: 'HasAuditHistory' , header: 'Audit', style: {width: '80px'}, show: true},
            { field: 'IsRelatedItem', header: 'Assign', style: {width: '70px'}, show: true  },
        ]
    }

    generateUnpostedRemittanceColumns(): void {
        this.UnpostedRemittanceColumns = [
            { field: 'AdjCode', header: 'Adj.', style: {width: '50px'}, show: true},
            { field: 'RawDataImport_ReceivedDate', header: 'Receive Date', style: '', show: true},
            { field: 'Prescription_PrescriptionNumber', header: 'Rx', style: '', show: true  },
            { field: 'Prescription_FillDate', header: 'Fill Date', style: '', show: true },
            { field: 'Money_PaymentStatusCode', header: 'Payment Status', style: '', show: true  },
            { field: 'Location_NCPDPProviderIdentifier', header: 'NCPDP', style: {}, show: true  },
            { field: 'Location_NationalProviderIdentifier', header: 'NPI', style: '', show: true  },
            { field: 'Location_CorporateLocationNumber', header: 'Store', style: {}, show: true  },
            { field: 'Payer_ProcessorIdentifier', header: 'Carrier', style: '', show: true  },
            { field: 'Payer_ShardPayerName', header: 'Carrier Name', style: '', show: true  },
            { field: 'Payer_ShardPayerGroupIdentifier', header: 'Carrier Group Id', style: '', show: true  },
            { field: 'Money_PaidAmount', header: 'Paid Amt.', style: {'text-align': 'right'} , show: true  },
            // { field: 'HasAuditHistory' , header: 'Audit', style: {width: '80px'}, show: true},
            { field: 'IsRelatedItem', header: 'Assign', style: {width: '70px'}, show: true  },
        ]
    }

    generateAdjCodeColumns(): void {
        this.AdjustmentCodeColumns = [
            { field: 'CLP03', header: 'Submitted Amt.(CLP03)', style: {'text-align': 'right'}, show: true},
            { field: 'CLP04', header: 'Paid Amt.(CLP04)', style: {'text-align': 'right'}, show: true  },
            { field: '91', header: 'Disp. Fee Adj.(91)', style: {'text-align': 'right'}, show: true },
            { field: '90', header: 'Ing. Cost Adj.(90)', style: {'text-align': 'right'}, show: true  },
            { field: '3', header: 'Co-pay Adj.(3)', style: {'text-align': 'right'}, show: true  },
            { field: '130', header: 'Claim Sub. Fee(130)', style: {'text-align': 'right'}, show: true  },
            { field: 'Other', header: 'Other Adj.', style: { width : '20%' }, show: true  },
        ]
    }

    generateTransactionHistoryColumns(): void {
        this.TransactionHistoryColumns = [
            { field: 'status', header: 'Select', style: {width: 80}, show: true, disabled: false},
            { field: 'Application_AssociationDate', header: 'Transaction Date', style: '', show: true},
            { field: 'Application_AccountingPeriod', header: 'Accounting Period', style: '', show: true},
            { field: 'Application_TransactionTypeDescription', header: 'Transaction Type', style: '', show: true},
            { field: 'Application_TransactionDetails', header: 'Transaction Details', style: {'width': '30%', 'text-align': 'left'}, show: true},
            { field: 'Application_Source', header: 'User', style: { width: '10%'}, show: true },
            { field: 'Money_TransactionAmount', header: 'Transaction Amount', style: {'text-align': 'right'}, show: true},
            { field: 'Money_ReceivableAmountAmount', header: 'A/R Balance', style: {'text-align': 'right'}, show: true},
            { field: 'Money_UnappliedAmount', header: 'UAC Balance', style: {'text-align': 'right'}, show: true},
        ];
    }

    generateAuditHistoryColumns(): void {
        this.AuditHistoryColumns = [
            { field: 'TimeStamp', header: 'When', style: '', show: true},
            { field: 'User', header: 'User', style: '', show: true},
            { field: 'ServiceEventId_From', header: 'From', style: '', show: true },
            { field: 'ServiceEventId_To', header: 'To', style: '', show: true },
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/helpers/event-search.tableHelper.ts